/**
 * ModuleDoorAnimState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleDoorAnimState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleDoorAnimState {
  DAMAGE    = 10014, // 328 - damage
  CLOSED    = 10022, // 333 - closed
  OPENED1   = 10050, // 331 - opened1
  OPENED2   = 10051, // 332 - opened2
  OPENING1  = 10052, // 334 - opening1
  OPENING2  = 10053, // 335 - opening2
  CLOSING1  = 10054, // 336 - closing1
  CLOSING2  = 10055, // 337 - closing2
  DEFAULT   = 10072, // 327 - default
  CONST1    = 10077, // 328 - damage
  BUSTED    = 10153, // 366 - busted
  TRANS     = 10269, // 344 - trans
};
